// @flow

export { ErrorLabel } from './error-label';
